import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  background: #EDF2F7;
  position: relative;
  z-index: 1;
`;

const BG1 = styled.img`
  position: absolute;
  pointer-events: none;
  top: 0%;
  left: -15%;
`

const BG2 = styled.img`
  position: absolute;
  pointer-events: none;
  bottom: -25%;
  right: -25%;
`

export default ({ children }) => {
  return (
    <Section>

      {children}
    </Section>
  )
}
